import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4edc5ec4-ec5f-472b-bcba-f68205338332',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: -385.20000000000005,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9'
    },
    {
      id: '946f1593-1de5-4e89-8184-d60ca8733062',
      type: 'Text',
      name: 'scoreLabel',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Score: %%%',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 56,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4edc5ec4-ec5f-472b-bcba-f68205338332'
    },
    {
      id: 'cbde13f4-fbbd-48be-8578-639863f80eba',
      type: 'Text',
      name: 'highscoreText',
      className: '',
      x: 0,
      y: 37.80000000000001,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Highscore: %%%',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: '#FFE41B',
        stroke: 'black',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4edc5ec4-ec5f-472b-bcba-f68205338332'
    },
    {
      id: '8b0e5124-22a6-496e-a274-7a9fa9f2b9cc',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 1.7999999999999545,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9'
    },
    {
      id: '8db008c0-8bd9-438e-8451-2f4909f9233d',
      type: 'Container',
      name: 'inputField',
      className: '',
      x: 0,
      y: -63,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b0e5124-22a6-496e-a274-7a9fa9f2b9cc'
    },
    {
      id: 'ead70ec2-f545-47ef-abb4-6db017e14057',
      type: 'Sprite',
      name: 'inputSprite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Score_Background',
      parent: '8db008c0-8bd9-438e-8451-2f4909f9233d'
    },
    {
      id: '07be360a-e0d9-416a-9763-6c33fa35233e',
      type: 'Text',
      name: 'inputLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Enter Your Name',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8db008c0-8bd9-438e-8451-2f4909f9233d'
    },
    {
      id: '0be548d6-4e5d-4bed-bc2f-d1bde65c6a98',
      type: 'Sprite',
      name: 'submitButton',
      className: '',
      x: 0,
      y: 64.80000000000007,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Touch_To_Continue_Button',
      parent: '8b0e5124-22a6-496e-a274-7a9fa9f2b9cc'
    },
    {
      id: 'fbe6e5a4-1451-4f1d-8364-48f864bc4437',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Submit Score',
      localize: true,
      maxWidth: 430,
      maxHeight: 80,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: '#276018',
        strokeThickness: 5,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 430,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0be548d6-4e5d-4bed-bc2f-d1bde65c6a98'
    },
    {
      id: '9360991d-accf-47f6-8b02-dfe875261085',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 387,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35dcaddd-f5a5-4e81-bdc0-dece3b8c9ab9'
    },
    {
      id: '132755ad-b0cd-4012-a092-b3b549b74acc',
      type: 'Sprite',
      name: 'continueButton',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Touch_To_Continue_Button',
      parent: '9360991d-accf-47f6-8b02-dfe875261085'
    },
    {
      id: '35fd2c57-248a-4b24-8d09-975dda5c293f',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play Again',
      localize: true,
      maxWidth: 430,
      maxHeight: 80,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'ARLRDBD',
        fill: 'white',
        stroke: '#276018',
        strokeThickness: 5,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 430,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '132755ad-b0cd-4012-a092-b3b549b74acc'
    }
  ],
  x: 50,
  y: 50,
  width: 421,
  height: 647,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  scoreLabel: boolean;
  highscoreText: boolean;
  inputField: boolean;
  inputSprite: boolean;
  inputLabel: boolean;
  submitButton: boolean;
  continueButton: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly scoreLabel: PIXI.Text;
  public readonly highscoreText: PIXI.Text;
  public readonly inputField: PIXI.Container;
  public readonly inputSprite: PIXI.Sprite;
  public readonly inputLabel: PIXI.Text;
  public readonly submitButton: PIXI.Sprite;
  public readonly continueButton: PIXI.Sprite;


  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
